module.exports = __webpack_public_path__ + "img/logo7.9478e782.png";